import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ao3SchemaForRoute } from "@/seo/ao3Schema";

const SCHEMA_MARK = "data-ao3-schema";

export default function Ao3Schema() {
  const { pathname } = useLocation();

  useEffect(() => {
    document
      .querySelectorAll(`script[${SCHEMA_MARK}]`)
      .forEach((node) => node.remove());

    const nodes = ao3SchemaForRoute(pathname);
    if (!nodes.length) {
      return;
    }

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute(SCHEMA_MARK, "1");
    script.textContent = JSON.stringify(nodes.length === 1 ? nodes[0] : nodes);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [pathname]);

  return null;
}